import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let req_url, img_req_url
if (process.env.NODE_ENV == 'development') {
  if (process.env.VUE_APP_FLAG === 'develop-test') {
    // 104开发模式
    req_url = 'http://47.93.50.140:8080'
    img_req_url = 'http://47.93.50.140:8001'
  } else {
    // 本地环境
    req_url = '/api'
    img_req_url = '/img'
  }
} else {
  req_url = 'https://panguapi.pgdxg.com'//http://www.pgdxg.com:8080
  img_req_url = 'https://pangubsapi.pgdxg.com'//http://www.pgdxg.com:8001
}

function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"]
    var flag = true
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break
        }
    }
    return flag
}

export default new Vuex.Store({
  state: {
    is_pc: IsPC(),
    user_key: '',
    user: '',
    user_mobile: '',
    req_url: req_url,
    img_req_url: img_req_url,
    // static_img_url: process.env.VUE_APP_FLAG === 'develop-test' ? 'http://47.93.50.140:8081':'http://localhost:7080',
    // static_img_url: 'http://47.93.50.140:80',
    static_img_url: 'http://www.pgdxg.com',
    first_load: false,
    status: [
      { id: '0', name: '待审核'},
      { id: '1', name: '已审核'},
      { id: '2', name: '作废'}
    ],
    activity_id: '1',
    footer_partner: [],
    footer_contact:{},
    apply_activity: []
  },
  mutations: {
    updateFirst(state, values) { // 判断是否首次加载
      state.first_load = values
    },
    updateUserKey(state, values) {
  		state.user_key = values
  	},
    updateUser(state, values) {
  		state.user = values
  	},
    updateUserMobile(state, values) {
      state.user_mobile = values
    },
    updateFooterPartner(state, values) {
      state.footer_partner = values
    },
    updateFooterContact(state, values) {
      state.footer_contact = values
    },
    updateApplyActivity(state, values) {
      state.apply_activity = values
    }
  },
  // actions: {
  //
  // }
})
